import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken, fmtErr } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = anon, {role} = logged
    const [error, setError] = useState("");

    const check = useCallback(async () => {
        const t = getToken();
        if (!t) {
            setUser(false);
            return;
        }
        try {
            const { data } = await api.get("/auth/me");
            setUser(data);
        } catch {
            setToken(null);
            setUser(false);
        }
    }, []);

    useEffect(() => {
        check();
    }, [check]);

    const login = async (password) => {
        setError("");
        try {
            const { data } = await api.post("/auth/login", { password });
            setToken(data.token);
            setUser({ role: data.role });
            return true;
        } catch (e) {
            setError(fmtErr(e.response?.data?.detail) || e.message);
            return false;
        }
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch {}
        setToken(null);
        setUser(false);
    };

    return (
        <AuthCtx.Provider value={{ user, error, login, logout, refresh: check }}>
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    return useContext(AuthCtx);
}
